import { PrinterListType } from 'components/PrintViewer/types';

export const testPrinters: PrinterListType = {
  printers: [
    {
      printerId: '782ee305-f6c7-4792-a157-d2fa6644ae0a',
      vendorPrinterId: 'fa55a502-f8c6-46b2-b8c0-041b0b2f13a5',
      printerName: '172.29.201.135',
      printerAlias: 'POR-4E-IOP-LS-M605',
      printerModel: 'CDK Laser Station M605',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: false },
        { departmentName: 'CHEV-A', isEnabled: true },
        { departmentName: 'CHEV-I', isEnabled: false },
        { departmentName: 'CHEV-S', isEnabled: false },
        { departmentName: 'GM-FI', isEnabled: false },
        { departmentName: 'GM-I', isEnabled: false },
        { departmentName: 'GM-A', isEnabled: true },
        { departmentName: 'GM-S', isEnabled: false },
        { departmentName: 'GM-SL', isEnabled: false }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray4',
          trayName: 'Tray4',
          paperSize: 'Letter',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/782ee305-f6c7-4792-a157-d2fa6644ae0a',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: 'b46f56aa-8163-42c9-858c-e4a8e141a931',
      vendorPrinterId: '366e1c0c-85c8-4f1e-aa3b-bb2d17e1c7ad',
      printerName: '139.126.224.230',
      printerAlias: 'HOF-1SW-PrinterLab-LS-605',
      printerModel: 'CDK Laser Station M605',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: true },
        { departmentName: 'CHEV-A', isEnabled: true },
        { departmentName: 'CHEV-I', isEnabled: true },
        { departmentName: 'CHEV-S', isEnabled: true },
        { departmentName: 'GM-FI', isEnabled: false },
        { departmentName: 'GM-I', isEnabled: false },
        { departmentName: 'GM-A', isEnabled: false },
        { departmentName: 'GM-S', isEnabled: false },
        { departmentName: 'GM-SL', isEnabled: false }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3',
          paperSize: 'Letter',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/b46f56aa-8163-42c9-858c-e4a8e141a931',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: 'b911b27d-7158-4dbb-9858-40d0aaf507c9',
      vendorPrinterId: 'f44686f6-5999-4e5e-8f3a-97dd29f4441a',
      printerName: '172.29.201.96',
      printerAlias: 'POR-4E-IOP-LS-6100',
      printerModel: 'CDK LaserStation 6100',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: true },
        { departmentName: 'CHEV-A', isEnabled: true },
        { departmentName: 'CHEV-I', isEnabled: false },
        { departmentName: 'CHEV-S', isEnabled: false },
        { departmentName: 'GM-FI', isEnabled: false },
        { departmentName: 'GM-I', isEnabled: true },
        { departmentName: 'GM-A', isEnabled: true },
        { departmentName: 'GM-S', isEnabled: true },
        { departmentName: 'GM-SL', isEnabled: false }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Multipurpose tray',
          trayName: 'Multipurpose tray',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Legal',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/b911b27d-7158-4dbb-9858-40d0aaf507c9',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: '6e9a0292-6f43-43bd-a8fb-1a334f06a765',
      vendorPrinterId: '2de9b761-ea8d-4826-a703-d2eebf08f400',
      printerName: '172.29.202.114',
      printerAlias: '172.29.202.114',
      printerModel: 'CDK LS M608',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: true },
        { departmentName: 'CHEV-A', isEnabled: true },
        { departmentName: 'CHEV-I', isEnabled: true },
        { departmentName: 'CHEV-S', isEnabled: true },
        { departmentName: 'GM-FI', isEnabled: true },
        { departmentName: 'GM-I', isEnabled: true },
        { departmentName: 'GM-A', isEnabled: true },
        { departmentName: 'GM-S', isEnabled: true },
        { departmentName: 'GM-SL', isEnabled: true }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3',
          paperSize: 'Legal',
          isEnabled: true
        },
        {
          trayId: 'Tray4',
          trayName: 'Tray4',
          paperSize: 'Letter',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/6e9a0292-6f43-43bd-a8fb-1a334f06a765',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: 'f8bd1218-cd9b-42e5-b7ad-47099dc02819',
      vendorPrinterId: '49fe5799-0262-454b-9402-11be69137111',
      printerName: '172.29.201.80',
      printerAlias: 'POR-3W-LS-M608',
      printerModel: 'CDK LS M608',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: false },
        { departmentName: 'CHEV-A', isEnabled: true },
        { departmentName: 'CHEV-I', isEnabled: true },
        { departmentName: 'CHEV-S', isEnabled: true },
        { departmentName: 'GM-FI', isEnabled: true },
        { departmentName: 'GM-I', isEnabled: true },
        { departmentName: 'GM-A', isEnabled: true },
        { departmentName: 'GM-S', isEnabled: true },
        { departmentName: 'GM-SL', isEnabled: false }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3',
          paperSize: 'Legal',
          isEnabled: true
        },
        {
          trayId: 'Tray4',
          trayName: 'Tray4',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray5',
          trayName: 'Tray5',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray6',
          trayName: 'Tray6',
          paperSize: 'Letter',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/f8bd1218-cd9b-42e5-b7ad-47099dc02819',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: 'd2b7e5f6-ca40-4ac2-b51a-04a2b0e871ca',
      vendorPrinterId: '685d6c38-1ae2-4eed-9d9a-b0c6c4c8d06f',
      printerName: 'Service-Virtual-Test',
      printerAlias: 'Service-Virtual-Test',
      printerModel: 'CDK LS M608',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: false },
        { departmentName: 'CHEV-A', isEnabled: false },
        { departmentName: 'CHEV-I', isEnabled: false },
        { departmentName: 'CHEV-S', isEnabled: false },
        { departmentName: 'GM-FI', isEnabled: false },
        { departmentName: 'GM-I', isEnabled: false },
        { departmentName: 'GM-A', isEnabled: false },
        { departmentName: 'GM-S', isEnabled: false },
        { departmentName: 'GM-SL', isEnabled: false }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3',
          paperSize: 'Legal',
          isEnabled: true
        },
        {
          trayId: 'Tray4',
          trayName: 'Tray4',
          paperSize: 'Letter',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/d2b7e5f6-ca40-4ac2-b51a-04a2b0e871ca',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: 'd75a1662-f148-4f10-a653-e88310286f21',
      vendorPrinterId: '1d32733d-d374-4b53-b18e-3cd7e5fafeea',
      printerName: 'Parts-Virtual-Test',
      printerAlias: 'Parts-Virtual-Test',
      printerModel: 'CDK LS M608',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: false },
        { departmentName: 'CHEV-A', isEnabled: false },
        { departmentName: 'CHEV-I', isEnabled: false },
        { departmentName: 'CHEV-S', isEnabled: false },
        { departmentName: 'GM-FI', isEnabled: false },
        { departmentName: 'GM-I', isEnabled: false },
        { departmentName: 'GM-A', isEnabled: false },
        { departmentName: 'GM-S', isEnabled: false },
        { departmentName: 'GM-SL', isEnabled: false }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3',
          paperSize: 'Legal',
          isEnabled: true
        },
        {
          trayId: 'Tray4',
          trayName: 'Tray4',
          paperSize: 'Letter',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/d75a1662-f148-4f10-a653-e88310286f21',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: 'a061b21d-38b8-40d9-ae4d-5f7ffb5f27b8',
      vendorPrinterId: '65512415-2864-4565-869a-499881fd4ae3',
      printerName: 'Sales-Virtual-Test',
      printerAlias: 'Sales-Virtual-Test',
      printerModel: 'CDK LS M608',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: false },
        { departmentName: 'CHEV-A', isEnabled: true },
        { departmentName: 'CHEV-I', isEnabled: false },
        { departmentName: 'CHEV-S', isEnabled: false },
        { departmentName: 'GM-FI', isEnabled: false },
        { departmentName: 'GM-I', isEnabled: false },
        { departmentName: 'GM-A', isEnabled: false },
        { departmentName: 'GM-S', isEnabled: false },
        { departmentName: 'GM-SL', isEnabled: false }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3',
          paperSize: 'Legal',
          isEnabled: true
        },
        {
          trayId: 'Tray4',
          trayName: 'Tray4',
          paperSize: 'Letter',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/a061b21d-38b8-40d9-ae4d-5f7ffb5f27b8',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: '45300e57-0cca-490f-8a5e-226054ba6063',
      vendorPrinterId: '2e2cd4c4-4c55-4e72-9563-398171832f4d',
      printerName: '172.29.202.113',
      printerAlias: 'POR-3W-LS-M605',
      printerModel: 'CDK Laser Station M605',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: true },
        { departmentName: 'CHEV-A', isEnabled: true },
        { departmentName: 'CHEV-I', isEnabled: true },
        { departmentName: 'CHEV-S', isEnabled: true },
        { departmentName: 'GM-FI', isEnabled: true },
        { departmentName: 'GM-I', isEnabled: true },
        { departmentName: 'GM-A', isEnabled: true },
        { departmentName: 'GM-S', isEnabled: true },
        { departmentName: 'GM-SL', isEnabled: true }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3 - Legal',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray4',
          trayName: 'Tray4',
          paperSize: 'Legal',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/45300e57-0cca-490f-8a5e-226054ba6063',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: 'bf5bb3f0-4b8d-4a5e-9725-9fd96333f859',
      vendorPrinterId: '6d798762-c5aa-4d7d-b222-f127dc2cf805',
      printerName: '172.29.201.81',
      printerAlias: 'POR-3W-CLS-M553',
      printerModel: 'CDK CLS M553',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: false },
        { departmentName: 'CHEV-A', isEnabled: false },
        { departmentName: 'CHEV-I', isEnabled: false },
        { departmentName: 'CHEV-S', isEnabled: false },
        { departmentName: 'GM-FI', isEnabled: false },
        { departmentName: 'GM-I', isEnabled: false },
        { departmentName: 'GM-A', isEnabled: false },
        { departmentName: 'GM-S', isEnabled: false },
        { departmentName: 'GM-SL', isEnabled: false }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3',
          paperSize: 'Legal',
          isEnabled: true
        },
        {
          trayId: 'Tray4',
          trayName: 'Tray4',
          paperSize: 'Letter',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/bf5bb3f0-4b8d-4a5e-9725-9fd96333f859',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: '3a6f5139-7df2-428c-8940-7b5bb9414082',
      vendorPrinterId: 'c8b8a64c-ce61-47b0-97d4-c0648f7978e9',
      printerName: '139.126.220.4',
      printerAlias: '139.126.220.4',
      printerModel: 'CDK LS M608',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: true },
        { departmentName: 'CHEV-A', isEnabled: true },
        { departmentName: 'CHEV-I', isEnabled: true },
        { departmentName: 'CHEV-S', isEnabled: true },
        { departmentName: 'GM-FI', isEnabled: true },
        { departmentName: 'GM-I', isEnabled: true },
        { departmentName: 'GM-A', isEnabled: true },
        { departmentName: 'GM-S', isEnabled: true },
        { departmentName: 'GM-SL', isEnabled: true }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        { trayId: 'Tray3', trayName: 'Tray3', paperSize: 'A4', isEnabled: true }
      ],
      links: [
        {
          href: '/printers/3a6f5139-7df2-428c-8940-7b5bb9414082',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: '9ada3f34-6dc9-49a8-91ca-c91bda17c5d9',
      vendorPrinterId: '8c9b0b7a-8cdd-40dc-8ba2-23dcdd0f42f6',
      printerName: '139.126.220.5',
      printerAlias: '139.126.220.5',
      printerModel: 'CDK CLS M553',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: true },
        { departmentName: 'CHEV-A', isEnabled: true },
        { departmentName: 'CHEV-I', isEnabled: true },
        { departmentName: 'CHEV-S', isEnabled: true },
        { departmentName: 'GM-FI', isEnabled: true },
        { departmentName: 'GM-I', isEnabled: true },
        { departmentName: 'GM-A', isEnabled: true },
        { departmentName: 'GM-S', isEnabled: true },
        { departmentName: 'GM-SL', isEnabled: true }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray4',
          trayName: 'Tray4',
          paperSize: 'Legal',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/9ada3f34-6dc9-49a8-91ca-c91bda17c5d9',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: '29ee462b-8674-44c0-99fe-0e650eca948a',
      vendorPrinterId: '8c9b0b7a-8cdd-40dc-8ba2-23dcdd0f42f6',
      printerName: '139.126.220.5',
      printerAlias: '139.126.220.5',
      printerModel: 'CDK CLS M553',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: true },
        { departmentName: 'CHEV-A', isEnabled: true },
        { departmentName: 'CHEV-I', isEnabled: true },
        { departmentName: 'CHEV-S', isEnabled: true },
        { departmentName: 'GM-FI', isEnabled: true },
        { departmentName: 'GM-I', isEnabled: true },
        { departmentName: 'GM-A', isEnabled: true },
        { departmentName: 'GM-S', isEnabled: true },
        { departmentName: 'GM-SL', isEnabled: true }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray4',
          trayName: 'Tray4',
          paperSize: 'Legal',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/29ee462b-8674-44c0-99fe-0e650eca948a',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: '88e0b3d8-f512-4d6b-9e38-843c8b3a9377',
      vendorPrinterId: 'c8b8a64c-ce61-47b0-97d4-c0648f7978e9',
      printerName: '139.126.220.4',
      printerAlias: '139.126.220.4',
      printerModel: 'CDK LS M608',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: true },
        { departmentName: 'CHEV-A', isEnabled: true },
        { departmentName: 'CHEV-I', isEnabled: true },
        { departmentName: 'CHEV-S', isEnabled: true },
        { departmentName: 'GM-FI', isEnabled: true },
        { departmentName: 'GM-I', isEnabled: true },
        { departmentName: 'GM-A', isEnabled: true },
        { departmentName: 'GM-S', isEnabled: true },
        { departmentName: 'GM-SL', isEnabled: true }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3',
          paperSize: 'Unknown',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/88e0b3d8-f512-4d6b-9e38-843c8b3a9377',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: 'beadd25c-9b64-459f-b000-6861a874bd53',
      vendorPrinterId: '1dfa336b-ecb6-4bba-8588-c9ffc5791d2d',
      printerName: '172.29.201.107',
      printerAlias: 'POR-4E-IOP-LS-M608',
      printerModel: 'CDK LS M608',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: true },
        { departmentName: 'CHEV-A', isEnabled: true },
        { departmentName: 'CHEV-I', isEnabled: false },
        { departmentName: 'CHEV-S', isEnabled: false },
        { departmentName: 'GM-FI', isEnabled: true },
        { departmentName: 'GM-I', isEnabled: true },
        { departmentName: 'GM-A', isEnabled: true },
        { departmentName: 'GM-S', isEnabled: true },
        { departmentName: 'GM-SL', isEnabled: true }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3',
          paperSize: 'Legal',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/beadd25c-9b64-459f-b000-6861a874bd53',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: '4588808f-0daf-4848-9d8d-cb32c1654bdc',
      vendorPrinterId: '101bf541-0bf8-47b5-bc16-bf040457c903',
      printerName: '172.29.202.120',
      printerAlias: 'POR-3W-LS-6100',
      printerModel: 'CDK LaserStation 6100',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: true },
        { departmentName: 'CHEV-A', isEnabled: true },
        { departmentName: 'CHEV-I', isEnabled: true },
        { departmentName: 'CHEV-S', isEnabled: true },
        { departmentName: 'GM-FI', isEnabled: true },
        { departmentName: 'GM-I', isEnabled: true },
        { departmentName: 'GM-A', isEnabled: true },
        { departmentName: 'GM-S', isEnabled: true },
        { departmentName: 'GM-SL', isEnabled: true }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Multipurpose tray',
          trayName: 'MPTray',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3',
          paperSize: 'Legal',
          isEnabled: true
        },
        {
          trayId: 'Tray4',
          trayName: 'null',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray5',
          trayName: 'null',
          paperSize: 'Letter',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/4588808f-0daf-4848-9d8d-cb32c1654bdc',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: '0f0bc3a8-2dd9-4ad5-be74-3adee4f1a0d6',
      vendorPrinterId: '77e6ddc9-a710-40f3-8b28-4ac11451fafe',
      printerName: 'Virtual_Printer',
      printerAlias: 'Virtual_Printer',
      printerModel: 'CDK LS M608',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: true },
        { departmentName: 'CHEV-A', isEnabled: true },
        { departmentName: 'CHEV-I', isEnabled: true },
        { departmentName: 'CHEV-S', isEnabled: true },
        { departmentName: 'GM-FI', isEnabled: true },
        { departmentName: 'GM-I', isEnabled: true },
        { departmentName: 'GM-A', isEnabled: true },
        { departmentName: 'GM-S', isEnabled: true },
        { departmentName: 'GM-SL', isEnabled: true }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3',
          paperSize: 'Legal',
          isEnabled: true
        },
        {
          trayId: 'Tray4',
          trayName: 'Tray4',
          paperSize: 'Letter',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/0f0bc3a8-2dd9-4ad5-be74-3adee4f1a0d6',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    },
    {
      printerId: 'd625c01f-8df5-40f4-8873-2ac497d36a4f',
      vendorPrinterId: '87afaf8c-6ac6-4d7a-a5eb-60b9f8b3f137',
      printerName: 'Accounting-Virtual-Test',
      printerAlias: 'Accounting-Virtual-Test',
      printerModel: 'CDK LS M608',
      storeId: 'S000000109',
      departments: [
        { departmentName: 'CHEV-FI', isEnabled: false },
        { departmentName: 'CHEV-A', isEnabled: true },
        { departmentName: 'CHEV-I', isEnabled: false },
        { departmentName: 'CHEV-S', isEnabled: false },
        { departmentName: 'GM-FI', isEnabled: false },
        { departmentName: 'GM-I', isEnabled: true },
        { departmentName: 'GM-A', isEnabled: true },
        { departmentName: 'GM-S', isEnabled: false },
        { departmentName: 'GM-SL', isEnabled: false }
      ],
      trayPaperSizeMappings: [
        {
          trayId: 'Tray1',
          trayName: 'Tray1',
          paperSize: 'Any Size',
          isEnabled: true
        },
        {
          trayId: 'Tray2',
          trayName: 'Tray2',
          paperSize: 'Letter',
          isEnabled: true
        },
        {
          trayId: 'Tray3',
          trayName: 'Tray3',
          paperSize: 'Legal',
          isEnabled: true
        },
        {
          trayId: 'Tray4',
          trayName: 'Tray4',
          paperSize: 'Letter',
          isEnabled: true
        }
      ],
      links: [
        {
          href: '/printers/d625c01f-8df5-40f4-8873-2ac497d36a4f',
          rel: 'update',
          method: 'PUT'
        }
      ],
      printerIP: ''
    }
  ]
};

export const printDataRequestPayload = {
  copies: 1,
  documentBase64encoded: '',
  duplex: true,
  printerId: '6e9a0292-6f43-43bd-a8fb-1a334f06a765',
  trayId: 'Tray2'
};

export const printDataResponse = {
  message: 'Successfully inserted'
};
